module.exports = __webpack_public_path__ + "static/media/iris-scan_grey.d69d3221.svg";